import { GridFilterModel } from '@mui/x-data-grid-pro';
import UsersGrid from './users-grid';
import { pagesConfig } from '../../shared/pages-config';
import { useUserSettings } from '../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import UsersIndexedGrid from './users-indexed-grid';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useRouteMatch } from '../../shared/useRouteMatch';
import { isFeatureEnabled } from '../../utils/feature-flags';

export default function UserManagement() {
  const {
    userRoles,
    changeLogRoles,
    limitedVisEnabled,
    viewType,
    currentTier,
    features,
  } = useUserSettings();
  const { userEmail } = useParams() as { userEmail: string | undefined };
  const location = useLocation();
  // Set by CommandDashboardTile's navigation (eg. the Active Users tile) when it wants the grid
  // to land pre-filtered instead of on the user's persisted saved-view filter.
  const presetFilterModel = (
    location.state as { presetFilter?: GridFilterModel } | null
  )?.presetFilter;

  const enterpriseBackendIndexingEnabled =
    isFeatureEnabled('indexUsersReact', features) &&
    currentTier === 'enterprise';

  const isFormPage = useRouteMatch([
    `${pagesConfig.users.link}/${pagesConfig.createUser.link}`,
  ]);

  if (userEmail || isFormPage) {
    return <Outlet />;
  }

  return (
    <SimpleBreadcrumbsPage
      bookmarkKey={pagesConfig.users.value}
      breadcrumbs={[{ label: pagesConfig.users.name }]}
    >
      {enterpriseBackendIndexingEnabled ? (
        <UsersIndexedGrid
          key={viewType.userManagementIndexedGridStates?.activeGridState}
          userRoles={userRoles}
          presetFilterModel={presetFilterModel}
        />
      ) : (
        <UsersGrid
          key={viewType.userManagementGridStates?.activeGridState}
          userRoles={userRoles}
          changeLogRoles={changeLogRoles}
          limitedVisEnabled={limitedVisEnabled}
          presetFilterModel={presetFilterModel}
        />
      )}
    </SimpleBreadcrumbsPage>
  );
}
